import {MediaState} from '../interfaces';

export const state: MediaState = {
  medias: [],
};
